import { Controller } from "@hotwired/stimulus"

export default class RealTimeValueController extends Controller {
  static values = {
    url: String,
    pollingInterval: { type: Number, default: 12_000 }
  }

  static targets = ["content"]

  connect() {
    this.startPolling()
    this.addTurboEventListeners()
  }

  disconnect() {
    this.removeTurboEventListeners()
    this.stopPolling()
  }

  addTurboEventListeners() {
    this.turboBeforeVisitHandler = this.handleTurboBeforeVisit.bind(this)
    document.addEventListener('turbo:before-visit', this.turboBeforeVisitHandler)
  }

  removeTurboEventListeners() {
    if (this.turboBeforeVisitHandler) {
      document.removeEventListener('turbo:before-visit', this.turboBeforeVisitHandler)
    }
  }

  handleTurboBeforeVisit() {
    this.stopPolling()
  }

  startPolling() {
    this.pollingTimer = setInterval(() => this.poll(), this.pollingIntervalValue)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  async poll() {
    if (this.isPolling || document.hidden) return

    this.isPolling = true

    try {
      const response = await fetch(this.urlValue, {
        method: 'GET',
        headers: { 'Accept': 'text/html' }
      })

      if (response.ok && this.hasContentTarget) {
        const html = await response.text()
        this.contentTarget.innerHTML = html
      }
    } catch (error) {
      console.error('[RealTimeValue] Polling error:', error)
    } finally {
      this.isPolling = false
    }
  }
}
